<script lang="ts">
  import { type FacetValue, Chip, ChipDeprecated } from "@otto-ec/heureka-components/facet-value";
  import { type FacetValueLabelOptions, Text } from "@otto-ec/heureka-components/facet-value-label";
  import DeselectAll from "../facetvaluetags/DeselectAll.svelte";
  import type { DeselectAllConfiguration } from "./type";
  import { OverflowBox } from "@otto-ec/heureka-components/facet-value-group";
  import { isActive } from "../toggle/Toggle";

  const defaultFacetValueLabelOptions: Partial<FacetValueLabelOptions> = {
    size: "75",
    showCount: false,
  };

  interface Props {
    deselectAll: DeselectAllConfiguration;
    values?: FacetValue[];
    hideDeselectAllOnDesktopView: boolean;
  }

  const { deselectAll, values, hideDeselectAllOnDesktopView }: Props = $props();
  const hasValues = values?.length > 0;
</script>

{#snippet closeIcon()}
  <oc-icon-v1 class="hc_facetValue__icon" type="close" size="50"></oc-icon-v1>
{/snippet}

{#snippet chip(facetValue: FacetValue)}
  {#if isActive("HEUREKA_1975_OC_CHIP_MIGRATION")}
    <!-- Remove checked attribute - render gray -->
    <Chip
      class={["hc_facetValueTag", { js_clearInput: facetValue.checked }]}
      {...facetValue}
      checked={undefined}
      showRemoveIcon={!!facetValue.checked}
      variantGray
    >
      <Text {...facetValue} {...defaultFacetValueLabelOptions} />
    </Chip>
  {:else}
    <ChipDeprecated class={[{ js_clearInput: facetValue.checked }]} variantGray {...facetValue}>
      <Text {...facetValue} {...defaultFacetValueLabelOptions} />
      {#if facetValue.checked}
        {@render closeIcon()}
      {/if}
    </ChipDeprecated>
  {/if}
{/snippet}

<div class="hc_facetValueTags">
  {#if hasValues}
    <div class="hc_facetValueTags__content">
      <div class="hc_facetValueTags__values">
        <OverflowBox {values} item={chip}></OverflowBox>
      </div>
      <div
        class="hc_facetValueTags__deselectAll"
        class:hc_facetValueTags__deselectAll--hide-desktop={hideDeselectAllOnDesktopView}
      >
        <DeselectAll {...deselectAll} />
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .hc_facetValueTags {
    margin-bottom: tokens.$oc-semantic-spacing-50;

    &__content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 14px 0;
    }

    &__values {
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none;

      .hc_facetValue__icon {
        width: tokens.$oc-semantic-spacing-75;
        height: tokens.$oc-semantic-spacing-75;
        margin-left: tokens.$oc-semantic-spacing-25;
      }
    }

    &__deselectAll {
      white-space: nowrap;
      text-align: right;
      padding-left: tokens.$oc-semantic-spacing-75;
      padding-right: tokens.$oc-semantic-spacing-25;
    }
  }
</style>
